import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { BalanceKycBackground, HourGlass } from 'src/assets';

import { useTranslation } from 'src/hooks';

import {
  Container,
  Img,
  CustomButton,
  CustomTypography,
  Wrapper,
  Description,
} from './styles';

const PendingKyc = () => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  const { t } = useTranslation();
  const handleButtonClick = () => navigate('/kyc');

  return (
    <Container imgUrl={BalanceKycBackground}>
      <CustomTypography
        type="headline"
        fontFamily="primaryBold"
        color={colors.text.interactive}
      >
        {t('pending_kyc_title')}
      </CustomTypography>
      <Wrapper>
        <Img src={HourGlass} />
        <Description
          type="bodyButton"
          fontFamily="primaryMedium"
          color={colors.text.interactive}
        >
          {t('pending_kyc_desc')}
        </Description>
      </Wrapper>
      <CustomButton onClick={handleButtonClick}>
        {t('pending_kyc_button_text')}
      </CustomButton>
    </Container>
  );
};

export default PendingKyc;
